import { BrandTokens } from "../../../@tokens/BrandTokens";
import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";

export const style: any = {
    theme: {
        motion: {
            transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
            transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
        },

        header: {
            height: '48px',
            backgroundColor: BrandTokens.NeutralColorHighPure,
            paddingLeft: GlobalTokens.SpacingSizeXxs,
            paddingRight: GlobalTokens.SpacingSizeXxs,
            paddingTop: GlobalTokens.SpacingSizeXxxs,
            paddingBottom: GlobalTokens.SpacingSizeXxxs,
            borderBottom: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.NeutralColorHighMedium}`,
            // Text
            fontFamily: BrandTokens.FontFamily,
            fontSize: GlobalTokens.FontSizeXs,
            fontWeight: BrandTokens.FontWeightBold,
            color: BrandTokens.NeutralColorLowDark,
            lineHeight: GlobalTokens.LineHeightLg
        },

        default: {
            height: '48px',
            backgroundColor: BrandTokens.NeutralColorHighPure,
            paddingLeft: GlobalTokens.SpacingSizeXxs,
            paddingRight: GlobalTokens.SpacingSizeXxs,
            paddingTop: GlobalTokens.SpacingSizeXxxs,
            paddingBottom: GlobalTokens.SpacingSizeXxxs,
            borderBottom: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.NeutralColorHighMedium}`,
            // Text
            fontFamily: BrandTokens.FontFamily,
            fontSize: GlobalTokens.FontSizeXs,
            fontWeight: BrandTokens.FontWeightRegular,
            color: BrandTokens.NeutralColorLowDark,
            lineHeight: GlobalTokens.LineHeightLg
        },

        striped: {
            backgroundColor: BrandTokens.NeutralColorHighLight
        },

        collapsable: {
            backgroundColor: BrandTokens.NeutralColorHighPure,
            paddingLeft: GlobalTokens.SpacingSizeXxs,
            paddingRight: GlobalTokens.SpacingSizeXxs,
            borderBottom: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.NeutralColorHighMedium}`,
        },

        accordionTable: {
            height: '72px',
            fontFamily: BrandTokens.FontFamily,
            fontSize: GlobalTokens.FontSizeXs,
            fontWeight: BrandTokens.FontWeightBold,
            color: BrandTokens.NeutralColorLowDark,
            lineHeight: GlobalTokens.LineHeightLg
        },

        accordionLabelIcon: {
            paddingLeft: GlobalTokens.SpacingSizeXxxs
        },

        contentRow: {
            borderTop: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.NeutralColorHighMedium}`
        },

        contentLabel: {
            fontFamily: BrandTokens.FontFamily,
            fontSize: GlobalTokens.FontSizeXs,
            fontWeight: BrandTokens.FontWeightMedium,
            color: BrandTokens.NeutralColorLowDark,
            lineHeight: GlobalTokens.LineHeightDefault,
            paddingBottom: GlobalTokens.SpacingSizeNano
        },

        contentData: {
            fontFamily: BrandTokens.FontFamily,
            fontSize: GlobalTokens.FontSizeXxs,
            fontWeight: BrandTokens.FontWeightRegular,
            color: BrandTokens.NeutralColorLowMedium,
            lineHeight: GlobalTokens.LineHeightDefault
        },

        states: {
            hover: {
                backgroundColor: hexToRGB(BrandTokens.BrandColorPrimaryLight, GlobalTokens.OpacityLevelMedium),
                // Text
                color: BrandTokens.BrandColorPrimaryDark
            }
        }
    }
}